import { Link } from 'react-router-dom';
import { MapPin, Users, ArrowRight, Building2 } from 'lucide-react';

const HallCard = ({ hall }) => {
  return (
    <div className="group bg-white rounded-2xl shadow-sm border border-gray-100 hover:shadow-lg hover:-translate-y-1.5 transition-all duration-300 overflow-hidden">
      {/* Image */}
      <div className="relative overflow-hidden">
        {hall.featured_image ? (
          <img
            src={hall.featured_image}
            alt={hall.name}
            className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-56 bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
            <Building2 className="w-16 h-16 text-white opacity-40" />
          </div>
        )}

        {/* Price badge – floats over image */}
        <div className="absolute top-3 right-3">
          <div className="bg-white/95 backdrop-blur-sm rounded-xl px-3 py-1.5 shadow-md border border-white/50">
            <span className="text-lg font-bold text-purple-700">
              ₹{Number(hall.celebration_price).toLocaleString()}
            </span>
            <span className="text-xs text-gray-400 font-medium">/day</span>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="p-5">
        <h3 className="text-lg font-bold text-gray-800 mb-2 leading-snug">{hall.name}</h3>

        <div className="flex items-center gap-4 text-sm text-gray-400 mb-3">
          <span className="flex items-center gap-1.5">
            <MapPin className="w-3.5 h-3.5 text-purple-500" />
            {hall.city}
          </span>
          <span className="flex items-center gap-1.5">
            <Users className="w-3.5 h-3.5 text-pink-500" />
            {hall.capacity} guests
          </span>
        </div>

        <p className="text-gray-500 text-sm leading-relaxed line-clamp-2 mb-4">
          {hall.description || 'No description available'}
        </p>

        {/* Amenities */}
        {hall.amenities && hall.amenities.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mb-5">
            {hall.amenities.slice(0, 3).map((amenity, index) => (
              <span
                key={index}
                className="inline-flex items-center bg-purple-50 text-purple-700 text-xs font-medium px-2.5 py-1 rounded-full"
              >
                {amenity}
              </span>
            ))}
            {hall.amenities.length > 3 && (
              <span className="inline-flex items-center bg-gray-100 text-gray-500 text-xs font-medium px-2.5 py-1 rounded-full">
                +{hall.amenities.length - 3} more
              </span>
            )}
          </div>
        )}

        {/* CTA */}
        <Link
          to={`/${hall.slug}`}
          className="group/cta flex items-center justify-between w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-semibold py-3 px-5 rounded-xl text-sm shadow-sm hover:shadow-md transition-all duration-300"
        >
          <span>View Details &amp; Availability</span>
          <ArrowRight className="w-4 h-4 group-hover/cta:translate-x-1 transition-transform duration-300" />
        </Link>
      </div>
    </div>
  );
};

export default HallCard;
